import React from 'react';
import { XCircleIcon } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-20 px-4 bg-dark" data-id="element-136">
      <div className="max-w-4xl mx-auto" data-id="element-137">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-white" data-id="element-138">
          Si tenés una Air Fryer probablemente te pasó esto:
        </h2>

        <div className="space-y-6" data-id="element-139">
          <div className="bg-red-950/20 border border-red-900/30 rounded-2xl p-6 flex items-start gap-4" data-id="element-140">
            <XCircleIcon className="w-8 h-8 text-red-500 flex-shrink-0 mt-1" data-id="element-141" />
            <p className="text-lg text-gray-300" data-id="element-142">
              La compraste con entusiasmo… pero después de unas semanas
              terminaste usando siempre las mismas 2 o 3 recetas.
            </p>
          </div>

          <div className="bg-red-950/20 border border-red-900/30 rounded-2xl p-6 flex items-start gap-4" data-id="element-143">
            <XCircleIcon className="w-8 h-8 text-red-500 flex-shrink-0 mt-1" data-id="element-144" />
            <p className="text-lg text-gray-300" data-id="element-145">
              Buscás ideas en internet y encontrás recetas con ingredientes
              difíciles, tiempos distintos o que simplemente no quedan bien.
            </p>
          </div>

          <div className="bg-red-950/20 border border-red-900/30 rounded-2xl p-6 flex items-start gap-4" data-id="element-146">
            <XCircleIcon className="w-8 h-8 text-red-500 flex-shrink-0 mt-1" data-id="element-147" />
            <p className="text-lg text-gray-300" data-id="element-148">
              Al final terminás usando muy poco tu Air Fryer o haciendo siempre
              lo mismo.
            </p>
          </div>
        </div>
      </div>
    </section>;
}